<template>
  <div class="has-mb-4 has-pr-4 filter-item" >
    <div  class="card search-pod search-pod--most-popular has-h-100 has-bg-gray-0 has-p-3 is-rounded-2" >
      <div class="row" >
        <div class="col" >
          <h2 class="is-h5 has-mb-3 has-mt-0 has-text-primary" >
            <a :href="link" :title="heading">{{ heading }}</a>
          </h2>
          <div class="search-debug">DEBUG | Category: {{ category }} | CategoryRank: {{ categoryRank }} | Importance: {{ importance }}</div>
        </div>
      </div>
      <div class="aspect-ratio-container is-4x3 is-d-block is-rounded-1" style="overflow: hidden;">
        <div class="aspect-ratio-content">
            <a :id="id" :href="link" v-if="isIcon"><i :class="`search-pod__icon ${icon}`"></i></a>
          <a :id="id" :href="link" :title="heading" v-if="!isIcon" ><img class="media-cover is-rounded-1" :src="`${image}?anchor=center&mode=crop&quality=80&width=800`" draggable="true" alt="" /></a>
        </div>
      </div>
      <p class="search-pod__text has-text-text has-mb-0">
        {{ text.substring(0, 82) }}&hellip;&nbsp;<a :href="link" class="search-pod__link" title="Read more">&raquo;<span class="screen-reader-only">Read more on {{ heading }}</span></a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "MostPopularResult",
  props: {
    heading: String,
    image: String,
    text: String,
    link: String,
    icon: String,
    category: String,
    categoryRank: Number,
    importance: Number,
    id: String,
  },
  data: function () {
    return {
      comparisonImageURL: "/Dist/images/logo-square.svg",
      firstMouseX: 0
    }
  },
  computed: {
    isIcon: function() {
      return this.icon !== undefined && this.icon !== "" && this.image.indexOf(this.comparisonImageURL) > -1;
    }
  },
  methods:{
    preventClickOnDrag(){
      let elem = document.getElementById(this.id);
      elem.addEventListener('mousedown', (e) => { this.firstMouseX = e.clientX; });
      elem.addEventListener('mouseup', (e) => {
        let lastMouseX = e.clientX;
        let diffMouseX = this.firstMouseX - lastMouseX;
        if (diffMouseX > 3 || diffMouseX < -3) {
          let href = elem.getAttribute("href")
          elem.removeAttribute("href");
          setTimeout( () => {elem.setAttribute("href",href);}, 50);
        }
      });
    }
  },
  mounted() {
    this.preventClickOnDrag();
  }
};
</script>